// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2BpyXPIcEEGAyocuR_BMKF {\n  margin-top: 15px;\n  border: 1px solid #e0e0e0;\n}\n\n._3EepMSsX_tdEftKi0jhmfw,\n._3XTzIWBEfwsdhIpmC6wFr- {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 .5em;\n  border-left: 1px solid #e0e0e0;\n}\n._3XTzIWBEfwsdhIpmC6wFr- {\n  border-left: none;\n}\n\n._2h82R1eIPcBOc17U9xu40B {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1em;\n  color: #bdbdbd;\n}\n", ""]);
// Exports
exports.locals = {
	"GridContainer": "_2BpyXPIcEEGAyocuR_BMKF",
	"cell": "_3EepMSsX_tdEftKi0jhmfw",
	"firstCell": "_3XTzIWBEfwsdhIpmC6wFr-",
	"noCells": "_2h82R1eIPcBOc17U9xu40B"
};
module.exports = exports;
